/**
* ModalTemplate
*/

class ModalTemplate {
    constructor(id, options) {
        if(!id) return;
        if(!options) options = {};

        if($('div.modal#' + id).length) {
            return $('div.modal#' + id);
        }

        var container = $('body');

        // var container = $('div.container');
        // if(!container.length) {
        //     container = $('body');
        // }

        var modal = $('<div class="modal" data-bs-backdrop="true" id="' + id + '" tabindex="-1" role="dialog" aria-labelledby="' + id + 'Label" aria-hidden="true"></div>').appendTo(container);

        modal.data('keyboard', (options.keyboard != undefined) ? options.keyboard : true);

        return modal;
    }
}

export { ModalTemplate }